<template>
  <b-col cols="12" md="6" lg="6" xl="6">
    <label :for="uniqueId">{{ title }} <span :class="`${required ? 'required-star' : ''}`"></span></label>
    <b-form-datepicker
      :id="uniqueId"
      v-model="dateValue"
      v-bind="labels['hu'] || {}"
      locale="hu"
      :show-decade-nav="false"
      :hide-header="true"
      menu-class="w-100"
      calendar-width="100%"
      :dropup="false"
      @shown="shown()"
      @hidden="hidden()"
    ></b-form-datepicker>
    <div v-if="error" class="date-error-message">
      {{ errorMessage }}
    </div>
  </b-col>
</template>

<script>
export default {
  props: {
    title: { type: String, required: true },
    uniqueId: { type: String, required: true },
    error: { type: Boolean },
    errorMessage: { type: String, required: false },
    required: { type: Boolean, required: false },
    alreadySelected: { type: String }
  },
  data() {
    return {
      dateValue: '',
      labels: {
        hu: {
          labelPrevDecade: 'Előző évtized',
          labelPrevYear: 'Előző év',
          labelPrevMonth: 'Múlt hónap',
          labelCurrentMonth: 'Jelenlegi hónap',
          labelNextMonth: 'Következő hónap',
          labelNextYear: 'Következő év',
          labelNextDecade: 'Jövő évtized',
          labelToday: 'Ma',
          labelSelected: 'Kiválasztott dátum',
          labelNoDateSelected: 'Nincs dátum kiválasztva',
          labelCalendar: 'Naptár',
          labelNav: 'Naptári navigáció',
          labelHelp: 'Navigálás a naptárban a nyílbillentyűkkel'
        }
      }
    }
  },
  methods: {
    shown() {
      this.$emit('which-component-is-open', this.uniqueId)
      this.$emit('shown', true)
    },
    hidden() {
      this.$emit('which-component-is-open', '')
      this.$emit('hidden', false)
    }
  },
  watch: {
    dateValue() {
      this.$emit('date-value', this.dateValue)
    }
  },
  mounted() {
    if (this.alreadySelected !== '') {
      this.dateValue = this.alreadySelected
    }
  }
}
</script>

<style>
.b-calendar .b-calendar-grid-body .col[data-date] .btn {
  width: 48px;
  height: 44px;
  background: #ffffff;
  box-shadow: 0px 13px 5px rgba(0, 0, 0, 0.01), 0px 8px 5px rgba(0, 0, 0, 0.05), 0px 3px 3px rgba(0, 0, 0, 0.09),
    0px 1px 2px rgba(0, 0, 0, 0.1), 0px 0px 0px rgba(0, 0, 0, 0.1);
  border-radius: 8px !important;
  margin-top: 30px !important;
  display: flex;
  align-items: center;
  justify-content: center;
  color: black;
}

.dropdown-menu {
  transform: translate3d(0px, 36px, 0px) !important;
}

#datepicker-1__outer_ {
  border: 2px solid #b2bec3 !important;
}

#datepicker-2__outer_ {
  border: 2px solid #b2bec3 !important;
}

#datepicker-3__outer_ {
  border: 2px solid #b2bec3 !important;
}

#datepicker-4__outer_ {
  border: 2px solid #b2bec3 !important;
}

.date-error-border {
  border: 2px solid #ba3b46 !important;
}

.date-error-message {
  color: #ba3b46;
  text-align: right;
  font-size: 14px;
}

@media (max-width: 993px) {
  .text-muted {
    font-size: 12px !important;
  }
  .b-calendar .b-calendar-grid-body .col[data-date] .btn {
    width: 36px;
    height: 33px;
  }
}

@media (max-width: 767px) {
  .text-muted {
    font-size: 10px !important;
  }
  .b-calendar .b-calendar-grid-body .col[data-date] .btn {
    width: 24px;
    height: 22px;
  }
}
</style>
